import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageStore } from '../../store/languageStore';
import { useCreateVisit } from '../../hooks/useVisits';
import { VisitForm } from '../../components/visits/VisitForm';
import { PageHeader } from '../../components/common/PageHeader';
import { CreateVisitDto } from '../../types/visit.types';
import toast from 'react-hot-toast';

export const AddVisitPage: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguageStore();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const patientId = searchParams.get('patientId')
    ? parseInt(searchParams.get('patientId')!, 10)
    : undefined;

  const createMutation = useCreateVisit();

  const handleSubmit = async (data: CreateVisitDto & { createPrescription?: boolean }) => {
    try {
      const visit = await createMutation.mutateAsync(data);
      
      if (data.createPrescription && visit) {
        // Redirect to prescription builder with the new visit ID
        toast.success(t('visits.visitCreated'));
        navigate(`/prescriptions/new?visitId=${visit.id}`);
      } else {
        // Redirect to patient profile
        toast.success(t('visits.visitCreated'));
        navigate(`/patients/${data.patientId}`);
      }
    } catch (error) {
      toast.error(t('visits.visitCreatedError', 'فشل في إنشاء الزيارة. يرجى المحاولة مرة أخرى.'));
      console.error('Error creating visit:', error);
    }
  };

  return (
    <div className="w-100" style={{ maxWidth: '100%', overflowX: 'hidden' }} dir={isRTL ? 'rtl' : 'ltr'}>
      <PageHeader title={t('visits.newVisit')} />
      <div className="row">
        <div className="col-12 col-lg-8 col-xl-6 mx-auto">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h5 className="card-title mb-0 fw-bold">{t('visits.newVisit')}</h5>
            </div>
            <div className="card-body">
              <VisitForm
                patientId={patientId}
                onSubmit={handleSubmit}
                isLoading={createMutation.isPending}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

